/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  SIGN_UP_USER: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.tribe.signUp.user',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'SIGN_UP_USER' },
      },
    },
    SIGN_UP_USER: {
      invoke: {
        id: 'addRole',
        src: 'addRole',
        onDone: {
          target: 'SIGN_UP_USER_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'SIGN_UP_USER_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    SIGN_UP_USER_FAILED: {
      on: {
        START: { target: 'SIGN_UP_USER' },
      },
    },
    SIGN_UP_USER_SUCCESS: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
